import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileInput from "../../../../components/inputs/file";
import TextInput from "../../../../components/inputs/text";
import TransmedProcessSlide from "./slide";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import TransmedCertificate from "../../../../dtos/transmed/process/process/certificate";
import { useState } from "react";
import { useSetError } from "../../../generic-error";
import { Link, useRevalidator } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import subtractOneSecond from "../../../../utils/subtractOneSecond";
import { externalRedirectUrl } from "../../../page-redirect";
import { IMAGE_HOST } from "../../../../server/config";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";
import TransmedProofService from "../../../../service/transmed/process/proof";

function TransmedProcessCertificate(props: {
  registration: TransmedRegistration;
  certificate: TransmedCertificate;
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const setError = useSetError();
  const revalidator = useRevalidator();

  const [file1, setFile1] = useState<File | null>(null);
  const [file2, setFile2] = useState<File | null>(null);
  const [file3, setFile3] = useState<File | null>(null);
  const [file4, setFile4] = useState<File | null>(null);
  const [file5, setFile5] = useState<File | null>(null);
  const [text, setText] = useState<string>(
    props.registration.certificate_text ?? ""
  );
  const [review, setReview] = useState<string>(props.registration.review ?? "");

  return (
    <TransmedProcessSlide style={{ gap: "var(--gap-medium)" }}>
      <h3>Certificat de participare</h3>
      <form
        onSubmit={async (e) => {
          e.preventDefault();

          setError("");
          setLoading(true);
          try {
            await new TransmedProofService().create.uploadDocuments(
              file1,
              file2,
              file3,
              file4,
              file5,
              text,
              review
            );
          } catch (error) {
            setError(error);
          } finally {
            setLoading(false);
            revalidator.revalidate();
          }
        }}
        className="surface"
        style={{
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap-medium)",
        }}
      >
        <h4>Încarcă documentele</h4>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap-small)",
          }}
          className="surface"
        >
          <b style={{ marginBottom: "var(--gap-medium)" }}>
            Adeverințe participare activități didactice
          </b>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--gap-small)",
            }}
          >
            <FileInput
              label="Adeverința 1"
              required
              types={["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]}
              disabled={
                new Date() < props.certificate.start ||
                new Date() > props.certificate.end ||
                (props.registration.participation_proof_checked &&
                  props.registration.participation_proof_message === null)
              }
              remoteValue={
                props.registration.participation_proof_1 ?? undefined
              }
              onChange={(files) => {
                if (files.length > 0) setFile1(files[0]);
              }}
            />
            <FileInput
              label="Adeverința 2"
              required
              types={["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]}
              disabled={
                new Date() < props.certificate.start ||
                new Date() > props.certificate.end ||
                (props.registration.participation_proof_checked &&
                  props.registration.participation_proof_message === null)
              }
              remoteValue={
                props.registration.participation_proof_2 ?? undefined
              }
              onChange={(files) => {
                if (files.length > 0) setFile2(files[0]);
              }}
            />
            <FileInput
              label="Adeverința 3"
              required
              types={["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]}
              disabled={
                new Date() < props.certificate.start ||
                new Date() > props.certificate.end ||
                (props.registration.participation_proof_checked &&
                  props.registration.participation_proof_message === null)
              }
              remoteValue={
                props.registration.participation_proof_3 ?? undefined
              }
              onChange={(files) => {
                if (files.length > 0) setFile3(files[0]);
              }}
            />
            <FileInput
              label="Adeverința 4"
              required
              types={["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]}
              disabled={
                new Date() < props.certificate.start ||
                new Date() > props.certificate.end ||
                (props.registration.participation_proof_checked &&
                  props.registration.participation_proof_message === null)
              }
              remoteValue={
                props.registration.participation_proof_4 ?? undefined
              }
              onChange={(files) => {
                if (files.length > 0) setFile4(files[0]);
              }}
            />
            <FileInput
              label="Adeverința 5"
              required
              types={["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]}
              disabled={
                new Date() < props.certificate.start ||
                new Date() > props.certificate.end ||
                (props.registration.participation_proof_checked &&
                  props.registration.participation_proof_message === null)
              }
              remoteValue={
                props.registration.participation_proof_5 ?? undefined
              }
              onChange={(files) => {
                if (files.length > 0) setFile5(files[0]);
              }}
            />
          </div>
          <div style={{ marginTop: "var(--gap-medium)" }}>
            Stagiile și cursurile care vor fi afișate pe diplomă pot diferi de
            cele la care ai participat. Te rugăm să introduci mai jos exact ceea
            ce ai dori să apară pe diplomă la secțiunea de activitate didactică.
          </div>
          <TextInput
            label="Activități afișate pe diplomă"
            required
            disabled={
              new Date() < props.certificate.start ||
              new Date() > props.certificate.end ||
              (props.registration.participation_proof_checked &&
                props.registration.participation_proof_message === null)
            }
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>
        <div
          className="surface"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap-small)",
          }}
        >
          <b style={{ marginBottom: "var(--gap-medium)" }}>
            Recenzie participare
          </b>
          <div>
            Împreună încercăm să îmbunătățim experiența transmed. Mai jos, te
            rugăm să ne spui câteva cuvinte despre cum te-ai simțit la{" "}
            {props.registration.confirmed_lc?.city}. Recenzia ta va apărea pe
            site, mai jos și va fi disponibilă participanților următori.
          </div>
          <TextInput
            label="Recenzie"
            required
            disabled={
              new Date() < props.certificate.start ||
              new Date() > props.certificate.end ||
              (props.registration.participation_proof_checked &&
                props.registration.participation_proof_message === null) ||
              props.registration.review_checked
            }
            value={review}
            onChange={(e) => setReview(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "var(--gap-small)",
          }}
        >
          <button
            type="submit"
            className="button primary"
            style={{ alignSelf: "flex-start" }}
            disabled={
              new Date() < props.certificate.start ||
              new Date() > props.certificate.end ||
              (props.registration.participation_proof_checked &&
                props.registration.participation_proof_message === null)
            }
          >
            Salvează datele
          </button>
          {(loading || revalidator.state === "loading") && <CircularProgress />}
        </div>
        <b style={{ color: "red" }}>
          Deadline încărcare documente:{" "}
          {subtractOneSecond(props.certificate.end).toLocaleDateString("RO-ro")}
          , ora{" "}
          {subtractOneSecond(props.certificate.end).toLocaleTimeString("RO-ro")}
        </b>
      </form>
      <div
        className="surface"
        style={{
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap-medium)",
          alignItems: "flex-start",
        }}
      >
        <h4>Descarcă certificatul</h4>
        {props.registration.certificate === null ? (
          <>
            <div>Certificatul va fi disponibil în curând.</div>
            <button className="button primary" disabled>
              <FontAwesomeIcon icon={faDownload} /> Descarcă
            </button>
          </>
        ) : (
          <Link
            to={externalRedirectUrl(
              IMAGE_HOST + props.registration.certificate
            )}
            className="button primary"
          >
            <FontAwesomeIcon icon={faDownload} /> Descarcă
          </Link>
        )}
      </div>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessCertificate;
